import { call, fork, take, put } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { Action } from 'typescript-fsa'

import { AboTopicsApi } from '../../api/instances'
import { Severity, EventType } from '@professocial/professocialTypes/types/messageTypes'
import { setMessage } from '../common/common.actions'
import i18n from 'i18next'

import {
  getTopicsAndMetadataForCurrentUser,
  getTopicsAndMetadataForCurrentUserInitiated,
} from './common.actions'

// getTopicsAndMetadataForCurrentUser
const getTopicsAndMetadataForCurrentUserWorker = bindAsyncAction(getTopicsAndMetadataForCurrentUser)(
  function * () {
    return yield call([AboTopicsApi, AboTopicsApi.getTopicsAndMetadataForCurrentUser])
  },
)

function * watchGetTopicsAndMetadataForCurrentUserInitiated () {
  while (true) {
    const action: Action<undefined> = yield take(getTopicsAndMetadataForCurrentUserInitiated)
    try {
      yield getTopicsAndMetadataForCurrentUserWorker(action.payload)
    } catch (e) {
      yield put(setMessage({
        severity: Severity.error,
        message: i18n.t('postMessages:loadingError', { context: i18n.t('postCommon:topics') }),
        eventType: EventType.load,
      }))
      console.error('error in watchGetTopicsAndMetadataForCurrentUserInitiated: ', e)
    }
  }
}

export function * commonSagas () {
  yield fork(watchGetTopicsAndMetadataForCurrentUserInitiated)
}
